const modalToggleHandlr = (onSetOrCreate, setModalAutoPlansActive, onClearTeamMemberFilter = () => {}) => {
  onSetOrCreate();
  setModalAutoPlansActive(false);
  onClearTeamMemberFilter();
};

export default modalToggleHandlr;
